import { render, staticRenderFns } from "./AddBankAccount.vue?vue&type=template&id=1890f792&"
import script from "./AddBankAccount.vue?vue&type=script&lang=js&"
export * from "./AddBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddBankAccount.vue?vue&type=style&index=0&id=1890f792&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports